<template>
  <div>
    <review-filters
      :orderNumber.sync="payload.orderNumber"
      :supplierId.sync="payload.supplierId"
      :rating.sync="payload.rating"
      @apply="getReviews(payload)"
    />
    <loading v-show="loading" />
    <v-card v-show="!loading" elevation="0" outlined>
      <v-app-bar flat dense elevation="0" color="transparent">
        <v-toolbar-title> <h4>Orders</h4> </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-app-bar>
      <v-divider></v-divider>
      <v-card-text class="pa-0">
        <template>
          <v-data-table
            :headers="headers"
            :items="reviews"
            show-select
            v-model="selected"
            :server-items-length="totalItems"
            :options.sync="pagination"
            :items-per-page="pagination.itemsPerPage"
            @pagination="updatePagination"
            :disable-pagination="false"
            :footer-props="{
              disablePagination: false,
              disableItemsPerPage: false
            }"
            class="elevation-0 black--text"
          >
            <template slot="item" slot-scope="props">
              <tr @click="detail(props.item.id)">
                <td>
                  <v-simple-checkbox
                    color="primary"
                    v-ripple
                    :value="isSelected"
                    @input="select($event)"
                  ></v-simple-checkbox>
                </td>
                <td class="text-left">
                  {{ props.item.createdAt | relativeCreationDate }}
                </td>
                <td class="text-left">
                  {{ props.item.leftBy }}
                </td>
                <td class="text-left">
                  {{ props.item.rating }}
                </td>
                <td class="text-left">
                  {{ props.item.comment }}
                </td>
                <td class="text-left">{{ props.item.supplier.name }}</td>
                <td class="text-left">
                  {{ props.item.user.firstName }} {{ props.item.user.lastName }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </template>
        <v-divider></v-divider>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
// eslint max-nested-callbacks: ["error", 10]
import moment from "moment";
import VuemomentJS from "vue-momentjs";
import Helpers from "@/mixins/helpers.js";
import ReviewFilters from "./ReviewFilters.vue";
export default {
  props: {
    payload: {
      type: Object,
      default: () => {
        return {
          from: 0,
          to: 10,
          supplierId: null,
          rating: null
        };
      }
    },
    module: {
      type: String,
      default: "suppliers/LOAD_REVIEWS"
    },
    actions: {
      type: Boolean,
      default: true
    }
  },
  components: {
    ReviewFilters
  },
  mixins: [Helpers],
  filters: {
    relativeCreationDate: function(date) {
      return moment.utc(date).fromNow();
    }
  },
  data() {
    let vm = this;
    return {
      supplierId: null,
      loading: true,
      selected: [],
      pagination: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: false,
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false
      },
      headers: [
        {
          text: "Created At",
          align: "left",
          sortable: false,
          value: "createdAt"
        },
        {
          text: "Left by",
          align: "left",
          sortable: false,
          value: "leftBy"
        },
        {
          text: "Rating",
          align: "left",
          sortable: false,
          value: "rating"
        },
        {
          text: "Comment",
          align: "left",
          value: "comment"
        },
        {
          text: "Supplier",
          align: "left",
          value: "supplier.name"
        },
        { text: "User", value: "user.firstName" }
      ]
    };
  },
  computed: {
    reviews() {
      return this.$store.state.suppliers.reviews;
    },
    totalItems() {
      return this.$store.state.suppliers.totalReviews;
    }
  },
  watch: {
    selected(val) {
      val.length > 0
        ? this.$emit("enable-action")
        : this.$emit("disable-action");
    }
  },
  created() {
    if (this.actions == false) {
      this.headers = this.headers.filter(column => column.value !== "action");
    }
    setTimeout(() => {
      this.getReviews(this.payload);
    }, 1000);
  },
  methods: {
    getReviews(payload) {
      this.$store
        .dispatch(this.module, payload)
        .then(response => {
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
          this.$swal("error", error.message, "error");
        });
    },
    updatePagination(pagination) {
      let payload = this.payload;
      (payload.from =
        pagination.page * pagination.itemsPerPage - pagination.itemsPerPage),
        (payload.to =
          pagination.itemsPerPage === -1
            ? this.totalItems
            : pagination.itemsPerPage);
      this.getReviews(payload);
    },
    async deleteAndRefresh(id) {
      let res = await this.destroy(id);
      if (res) {
        let payload = {
          from:
            this.pagination.page * this.pagination.itemsPerPage -
            this.pagination.itemsPerPage,
          to:
            this.pagination.itemsPerPage === -1
              ? this.totalItems
              : this.pagination.itemsPerPage
        };
        this.getReviews(payload);
      }
    }
  }
};
</script>
